import { Directive, HostListener } from "@angular/core";
import { keyPressTH } from "src/app/functions/string-formatter.function";

@Directive({
  selector: '[excludeTh]'
})
export class ExcludeThDirective {

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const isValid = keyPressTH(event);
    if (!isValid) {
      event.preventDefault();
    }
  }
}